import { Label } from "@/components/ui/label";

/**
 * A field label that says whether the field is required.
 *
 * The asterisk was plain text in the two forms that had one at all, and the fields the
 * server actually refuses were not the fields carrying it: an employee needs a unit and
 * a department, and neither was marked, so the only way to find out was to submit.
 *
 * The mark is hidden from assistive tech and replaced with the word, because "star" read
 * aloud after a label is not an instruction.
 */
export function FieldLabel({ htmlFor, children, required = false, className }) {
  return (
    <Label htmlFor={htmlFor} className={className}>
      {children}
      {required && (
        <>
          <span className="text-destructive-text ml-0.5" aria-hidden="true">*</span>
          <span className="sr-only"> (required)</span>
        </>
      )}
    </Label>
  );
}
